<template>
  <div class="home-page">
    <AppHeader />

    <main class="home-page__main">
      <ScrollReveal>
        <template #default="{ visible }">
          <HeroSection :visible="visible" />
        </template>
      </ScrollReveal>

      <ScrollReveal>
        <template #default="{ visible }">
          <HistoryAccordion :visible="visible" />
        </template>
      </ScrollReveal>

      <ScrollReveal>
        <template #default="{ visible }">
          <KnowledgeMapSection :visible="visible" />
        </template>
      </ScrollReveal>

      <ScrollReveal>
        <template #default="{ visible }">
          <RelationshipGraphSection :visible="visible" />
        </template>
      </ScrollReveal>
    </main>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import ScrollReveal from '@/components/common/ScrollReveal.vue'
import HeroSection from './components/HeroSection.vue'
import HistoryAccordion from './components/HistoryAccordion.vue'
import KnowledgeMapSection from './components/KnowledgeMapSection.vue'
import RelationshipGraphSection from './components/RelationshipGraphSection.vue'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    AppFooter,
    ScrollReveal,
    HeroSection,
    HistoryAccordion,
    KnowledgeMapSection,
    RelationshipGraphSection
  },
  mounted() {
    document.documentElement.classList.add('hide-scrollbar')
  },
  beforeDestroy() {
    document.documentElement.classList.remove('hide-scrollbar')
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: $color-paper;

  &__main {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  }
}
</style>
